
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PlanManagement from './PlanManagement';
import EntrepriseAccountSettings from './EntrepriseAccountSettings';

const PlatformConfigTab = () => {
  return (
    <Tabs defaultValue="plans" className="w-full">
      <TabsList className="mb-4">
        <TabsTrigger value="plans">Forfaits</TabsTrigger>
        <TabsTrigger value="enterprise">Comptes entreprise</TabsTrigger>
        <TabsTrigger value="settings">Paramètres généraux</TabsTrigger>
      </TabsList>
      
      <TabsContent value="plans">
        <PlanManagement />
      </TabsContent>
      
      <TabsContent value="enterprise">
        <EntrepriseAccountSettings />
      </TabsContent>
      
      <TabsContent value="settings">
        <div className="rounded-md border p-8 text-center">
          <h3 className="text-lg font-medium mb-2">Paramètres généraux</h3>
          <p className="text-gray-500">Les paramètres généraux de la plateforme seront disponibles prochainement.</p>
        </div>
      </TabsContent>
    </Tabs>
  );
};

export default PlatformConfigTab;
